export default __webpack_public_path__ + "static/media/help.64c3c26c.svg";